import * as api from "@/api/williams/project";
import { ProjectFilters } from "@/api/williams/project";
import { queryKeys } from "../../queryKeys";
import { useInfiniteQuery } from "react-query";

const PAGE_SIZE = 100;

export function useProjectList(filters: Partial<ProjectFilters> = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.project.filter(filters),
    queryFn: ({ pageParam = 0 }) => {
      const skip = pageParam * PAGE_SIZE;
      return api.getProjectList({ skip, take: PAGE_SIZE, ...filters });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.results.length === PAGE_SIZE) {
        return allPages.length;
      }
    },
  });
}
